import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";

import todoReducer from "./reducer/todoReducer";

export const rootReducer = combineReducers({
    todo: todoReducer
});


export const store = createStore(
    rootReducer,
    compose(
        applyMiddleware(thunk),
        //window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
    )
);
